export default "__VITE_ASSET__CgRAkOu___"